// extracted by mini-css-extract-plugin
export default {"root":"expandBtn-module--root--zxHtc","expandIcon":"expandBtn-module--expandIcon--NSnxL","expanded":"expandBtn-module--expanded--svNTq"};